import { Link } from '@mui/material';
import { toTitleCase } from 'helpers';

export interface TrackingLinkProps {
    trackingLink?: string;
    deliveryCarrier?: string;
}

export const TrackingLink = ({
    trackingLink,
    deliveryCarrier,
}: TrackingLinkProps) => {
    return (
        <>
            {trackingLink ? (
                <Link
                    target="__blank"
                    href={trackingLink}
                    data-testid="TrackingLink"
                >
                    {deliveryCarrier
                        ? `${toTitleCase(deliveryCarrier)} Tracking Link`
                        : 'Tracking Link'}
                </Link>
            ) : (
                <span data-testid="TrackingLink-NA">N/A</span>
            )}
        </>
    );
};
